import AuthService from "../login/auth.service";
import { comprobantes } from "../../components/generico/utils/UrlAPI";
import axios from "axios";

class FacturaService {
  async obtenerListadoFacturas(mes, anio) {
    var config = {
      method: "get",
      url:
        comprobantes +
        "comprobantes/listar?canal=WEB&anho=" +
        anio +
        "&mes=" +
        mes,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
    };
    return await axios(config);
  }

  async descagarReporte(tipo, recibo, nroSerie, fechaEmision) {
    var _url = comprobantes + "documentos/v2/" + tipo + "?";

    _url =
      _url +
      "canal=web&recibo=" +
      recibo +
      "&numeroSerie=" +
      nroSerie +
      "&fechaEmision=" +
      fechaEmision;

    var config = {
      method: "get",
      url: _url,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
    };
    return await axios(config);
  }
}
export default new FacturaService();
